import { createFileRoute } from "@tanstack/react-router";

import InternalDocs from "../pages/InternalDocs";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/internal-docs")({
  component: InternalDocsRoute,
});

function InternalDocsRoute() {
  return (
    <RequireAuth require="admin">
      <InternalDocs />
    </RequireAuth>
  );
}
